import { CSSProperties, ReactElement } from 'react';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ErrorBoundary, mapSharedPropertiesToFields } from '@gn-audio/jss-components';

import { CondensedMenuWrapper } from 'common/condensedMenu/withCondensedMenu';

type SpotWrapperProps = {
  component: ReactElement;
  rendering: ComponentRendering;
};

export type JSSComponentFields = {
  topPaddingMobile: Field<string>;
  bottomPaddingMobile: Field<string>;

  topPaddingDesktop: Field<string>;
  bottomPaddingDesktop: Field<string>;

  topPaddingTablet: Field<string>;
  bottomPaddingTablet: Field<string>;
  data?: {
    item: {
      topPaddingMobile: Field<string>;
      bottomPaddingMobile: Field<string>;

      topPaddingDesktop: Field<string>;
      bottomPaddingDesktop: Field<string>;

      topPaddingTablet: Field<string>;
      bottomPaddingTablet: Field<string>;
    };
  };
};
export const SpotWrapper = ({ component, rendering }: SpotWrapperProps) => {
  const parsedProps = rendering.fields
    ? mapSharedPropertiesToFields<JSSComponentFields>(rendering.fields)
    : null;

  const paddingFields: Array<Exclude<keyof JSSComponentFields, 'data'>> = [
    'topPaddingMobile',
    'bottomPaddingMobile',
    'topPaddingDesktop',
    'bottomPaddingDesktop',
    'topPaddingTablet',
    'bottomPaddingTablet',
  ];

  const paddingProps = parsedProps?.data ? parsedProps.data.item : parsedProps;

  const hasCustomPaddings =
    paddingProps && paddingFields.some((field) => paddingProps[field]?.value);

  let topPaddingMobile, topPaddingTablet, topPaddingDesktop;
  let bottomPaddingMobile, bottomPaddingTablet, bottomPaddingDesktop;

  if (hasCustomPaddings) {
    topPaddingMobile = paddingProps?.topPaddingMobile.value;
    topPaddingTablet = paddingProps?.topPaddingTablet.value || topPaddingMobile;
    topPaddingDesktop = paddingProps?.topPaddingDesktop.value || topPaddingTablet;

    bottomPaddingMobile = paddingProps?.bottomPaddingMobile.value;
    bottomPaddingTablet = paddingProps?.bottomPaddingTablet.value || bottomPaddingMobile;
    bottomPaddingDesktop = paddingProps?.bottomPaddingDesktop.value || bottomPaddingTablet;
  }

  const style = {
    '--top-padding-mobile': topPaddingMobile,
    '--top-padding-tablet': topPaddingTablet,
    '--top-padding-desktop': topPaddingDesktop,
    '--bottom-padding-mobile': bottomPaddingMobile,
    '--bottom-padding-tablet': bottomPaddingTablet,
    '--bottom-padding-desktop': bottomPaddingDesktop,
    backfaceVisibility: 'hidden',
  } as CSSProperties;

  const wrappedComponent = (
    <CondensedMenuWrapper rendering={rendering}>{component}</CondensedMenuWrapper>
  );

  return (
    <ErrorBoundary name={rendering.componentName}>
      {!hasCustomPaddings ? wrappedComponent : <div style={style}>{wrappedComponent}</div>}
    </ErrorBoundary>
  );
};
